import React, { Fragment, useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { Row, Col, Form, Label, FormGroup, Button, Input } from "reactstrap";
import RequiredField, {
  FirstName,
  LastName,
  Submit,
  Cancel,
  BirthDate,
  Age,
  MobileNo,
  AadharNumber,
  Password,
  ConfirmPassword,
  Gender,
  Address,
  Category,
} from "../../../Constant";
import { Breadcrumbs } from "../../../AbstractElements";
import { useNavigate, useLocation } from "react-router";
import {
  CreateStaff,
  StaffCategoryList,
  UpdateStaff,
} from "../../../apiController";
import { toast } from "react-toastify";

const StaffForm = ({ setSteps }) => {
  const navigate = useNavigate();

  const location = useLocation();
  const [department, setDepartment] = useState([]);
  const [base64, setBase64] = useState("");

  const { rowData } = location.state || {};

  const [formdata, setFormdata] = useState({});
  const [url, setUrl] = useState("");

  console.warn(rowData)

  const readUrl = (event) => {
    if (event.target.files.length === 0) return;
    var mimeType = event.target.files[0].type;

    if (mimeType.match(/image\/*/) == null) {
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      setUrl(reader.result);
    };
  };

  const {
    control,
    register,
    watch,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm();

  const [age, setAge] = useState("");

  useEffect(() => {
    if (rowData?.dob) {
      reset({
        birthday: rowData.dob,
      });


      setValue('department', rowData.staff_category_id)
    }
  }, [rowData, reset]);

  // Watch for changes in the birthday field
  const dob = watch("birthday");

  useEffect(() => {
    if (dob) {
      const dobDate = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - dobDate.getFullYear();
      const monthDiff = today.getMonth() - dobDate.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < dobDate.getDate())
      ) {
        age--;
      }
      setAge(age);
      setValue("age", age); 
    }
  }, [dob, setValue]);

  const onSubmit = async (data) => {
    // console.log(data)
    setFormdata((prev) => ({ ...prev, ...data }));
    // setSteps((prev) => prev + 1);
    console.warn(data);

    const formattedData = {
      image: data.image?.toString(),
      first_name: data.firstName.toString(),
      surname: data.lastname,
      staff_category_id: String(data.department),
      phone: data.phone.toString(),
      qualification: data.qualification,
      email: data.email,
      address: data.addr,
      age: data.age,
      dob: data.birthday,
      gender: data.gender,
      aadhar_number: data.aadharnumber.toString(),
      password: data.password,
      confirm_password: data.confirmpassword,
      id: rowData ? rowData.id : "",
    };
    console.error(formattedData);
    try {
      if (rowData) {
        const response = await UpdateStaff(formattedData);
        if (response.status === true) {
          toast.success("Updated Successfully!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
        // navigate(`${process.env.PUBLIC_URL}/staff/:layout>}`);
      } else {
        const response = await CreateStaff(formattedData);
        if (response.status === true) {
          toast.success("Created Successfully!", {
            position: toast.POSITION.TOP_CENTER,
          });
        } else if (response.status === false) {
          toast.error(response.message, {
            position: toast.POSITION.TOP_CENTER,
          });
        }
        // navigate(`${process.env.PUBLIC_URL}/staff/:layout>}`);
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    }finally{

      reset();
    }
  };
  // const onSubmit = (data) => {
  //   setFormdata((prev) => ({ ...prev, ...data }));
  //   setSteps((prev) => prev + 1);
  // };

  const today = new Date().toISOString().split("T")[0];

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64(reader.result);
        console.warn(reader.result)
        setValue("image", reader.result); // Set base64 string in form
      };
      reader.readAsDataURL(file);
    }
    else {
      // If no file is selected, clear the image value in the form
      setBase64(''); // Reset base64 state if needed
      setValue("image", ''); // Clear the form field
    }
  };

  const fetchStaffDepartment = async () => {
    const response = await StaffCategoryList();
    if (response.status === true) {
      setDepartment(response.data);
    }
  };

  useEffect(() => {
    fetchStaffDepartment();
  }, []);

  return (
    <Fragment>
      <Breadcrumbs parent="Staff" mainTitle="Staff Form" title="Staff Form" />
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="form-bookmark needs-validation"
      >
        <Row>
          <Col sm="12" xl="6" className="custom-padding-lg">
            {!rowData && (
              <FormGroup className="mb-3">
                {!base64 && (
                  <>
                    <Label htmlFor="fname">{"Image"}</Label>
                    <input
                      className={`form-control ${errors.image && "is-invalid"}`}
                      id="image"
                      type="file"
                      name="firstname"
                      accept=".jpg, .jpeg, .png"
                      defaultValue={formdata.image || ""}
                      {...register("image", { required: false })}
                      onChange={handleFileChange}
                    />
                    <span className="text-danger">
                      {errors.image && "Image is required"}
                    </span>
                  </>
                )}
                {base64 && (
                  <div>
                    <img
                      src={base64}
                      alt="Selected"
                      style={{ maxWidth: "100px", maxHeight: "100px" }}
                    />
                    {/* <textarea readOnly value={base64} rows="4" cols="50" /> */}
                  </div>
                )}
              </FormGroup>
            )}
            <FormGroup className="mb-3">
              <Label htmlFor="fname">
                {FirstName} <RequiredField />
              </Label>
              <input
                className={`form-control ${errors.firstName && "is-invalid"}`}
                id="fname"
                type="text"
                name="firstname"
                defaultValue={rowData?.first_name || ""}
                {...register("firstName", { required: true })}
              />
              <span className="text-danger">
                {errors.firstName && "First name is required"}
              </span>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="lname">
                {LastName} <RequiredField />
              </Label>
              <input
                className={`form-control ${errors.lastname && "is-invalid"}`}
                id="lname"
                type="text"
                name="lastname"
                defaultValue={rowData?.surname || ""}
                {...register("lastname", { required: true })}
              />
              <span className="text-danger">
                {errors.lastname && "Last name is required"}
              </span>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="mobilenumber">
                {MobileNo} <RequiredField />
              </Label>
              <input
                className={`form-control ${errors.phone && "is-invalid"}`}
                id="phone"
                type="number"
                name="phone"
                maxLength={10}
                defaultValue={rowData?.phone || ""}
                {...register("phone", {
                  required: true,
                  minLength: {
                    value: 10,
                    message: "Phone number must be at least 10 digits",
                  },
                  maxLength: {
                    value: 10,
                    message: "Phone number must be exactly 10 digits",
                  },
                  pattern: {
                    value: /^[0-9]+$/,
                    message: "Phone number must contain only digits",
                  },
                })}
              />
              <span className="text-danger">
                {errors.age && "MobileNo is required"}
              </span>
            </FormGroup>
            {/* <FormGroup className="mb-3">
              <Label htmlFor="Bdate">
                {BirthDate} <RequiredField />
              </Label>
              <input
                className={`form-control ${errors.birthday && "is-invalid"}`}
                id="Bdate"
                type="date"
                name="birthday"
                defaultValue={rowData?.dob || ""}
                {...register("birthday", { required: true })}
                max={today}
              />
              <span className="text-danger">
                {errors.birthday && "Birth Date is required"}
              </span>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="age">
                {Age}
                <RequiredField />
              </Label>
              <input
                className={`form-control ${errors.age && "is-invalid"}`}
                id="age"
                type="number"
                name="age"
                max="100"
                defaultValue={rowData?.age || ""}
                {...register("age", {
                  required: true,
                  pattern: {
                    value: /^[0-9]+$/,
                    message: "Age must contain only digits",
                  },
                })}
              />
              <span className="text-danger">
                {errors.age && "Age is required"}
              </span>
            </FormGroup> */}
            <FormGroup className="mb-3">
                <Label htmlFor="Bdate">
                  {BirthDate} <RequiredField />
                </Label>
                <Controller
                  control={control}
                  name="birthday"
                  render={({ field }) => (
                    <input
                      {...field}
                      className={`form-control ${
                        errors.birthday && "is-invalid"
                      }`}
                      id="Bdate"
                      type="date"
                      max={new Date().toISOString().split("T")[0]} // Ensure max date is today
                    />
                  )}
                />
                <span className="text-danger">
                  {errors.birthday && "Birth Date is required"}
                </span>
              </FormGroup>
              <FormGroup className="mb-3">
                <Label htmlFor="age">
                  {Age} <RequiredField />
                </Label>
                <input
                  className={`form-control ${errors.age && "is-invalid"}`}
                  id="age"
                  type="number"
                  name="age"
                  value={age}
                  disabled
                />
                <span className="text-danger">
                  {errors.age && "Age is required"}
                </span>
              </FormGroup>
            <FormGroup>
              <Label htmlFor="gender">
                Gender <RequiredField />
              </Label>
              <div className="d-flex gap-3">
                <div className="custom-control custom-radio">
                  <Controller
                    name="gender"
                    control={control}
                    rules={{ required: false }}
                    render={({ field }) => (
                      <>
                        <Input
                          className="custom-control-input"
                          id="male"
                          type="radio"
                          value={
                            rowData?.gender === "male" ? rowData?.gender : ""
                          }
                          checked={field.value === "male"}
                          onChange={() => field.onChange("male")}
                        />
                        <Label className="custom-control-label" htmlFor="male">
                          Male
                        </Label>
                      </>
                    )}
                  />
                </div>
                <div className="custom-control custom-radio">
                  <Controller
                    name="gender"
                    control={control}
                    rules={{ required: false }}
                    render={({ field }) => (
                      <>
                        <Input
                          className="custom-control-input"
                          id="female"
                          type="radio"
                          value={
                            rowData?.gender === "female" ? rowData?.gender : ""
                          }
                          checked={field.value === "female"}
                          onChange={() => field.onChange("female")}
                        />
                        <Label
                          className="custom-control-label"
                          htmlFor="female"
                        >
                          Female
                        </Label>
                      </>
                    )}
                  />
                </div>
              </div>
            </FormGroup>

            <FormGroup className="mb-3">
              <Label htmlFor="exampleFormControlSelect9">
                {"Role"} <RequiredField />
              </Label>
              <select
                type="select"
                name="department"
                className="form-control digits"
                id="department"
                value={rowData?.staff_category_id}
                {...register("department", { required: true })}
              >
                <option value="">{"Select Staff Category"}</option>
                {department.map((type) => (
                  <option key={type.id} value={type.id}>
                    {type.name}
                  </option>
                ))}
              </select>
              <span className="text-danger">
                {errors.department && "Staff is required"}
              </span>
            </FormGroup>
          </Col>
          <Col sm="12" xl="6" className="custom-padding-lg mb-3">
            <FormGroup className="mb-3">
              <Label htmlFor="address">{Address}</Label>
              <input
                type="textarea"
                className={`form-control ${errors.addr && "is-invalid"}`}
                rows="3"
                id="addr"
                name="addr"
                defaultValue={rowData?.address || ""}
                {...register("addr", { required: false })}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="email">{"Email Address"}</Label>
              <input
                className={`form-control ${errors.email && "is-invalid"}`}
                id="email"
                type="email"
                name="email"
                defaultValue={rowData?.email || ""}
                {...register("email", { required: false })}
              />
              {/* <span className="text-danger">{errors.email && "Email is required"}</span> */}
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="qualification">{"Qualification"}</Label>
              <input
                className={`form-control ${errors.profession && "is-invalid"}`}
                id="qualification"
                type="text"
                name="qualification"
                defaultValue={rowData?.qualification || ""}
                {...register("qualification", { required: false })}
              />
              <span className="text-danger">
                {errors.qualification && "qualification is required"}
              </span>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="aadharnumber">
                {AadharNumber} <RequiredField />{" "}
              </Label>
              <input
                className={`form-control ${
                  errors.aadharnumber && "is-invalid"
                }`}
                id="aadharnumber"
                type="number"
                name="aadharnumber"
                maxLength="12"
                defaultValue={rowData?.aadhar_number || ""}
                {...register("aadharnumber", { required: true })}
              />
              {/* <span className="text-danger">{errors.contactnumber && "contactnumber is required"}</span> */}
            </FormGroup>
            {!rowData && (
              <>
                <FormGroup className="mb-3">
                  <Label htmlFor="password">
                    {Password} <RequiredField />
                  </Label>
                  <input
                    className={`form-control ${
                      errors.password && "is-invalid"
                    }`}
                    id="password"
                    type="password"
                    name="password"
                    defaultValue={formdata.password || ""}
                    {...register("password", { required: false })}
                  />
                  <span className="text-danger">
                    {errors.password && "password Name is required"}
                  </span>
                </FormGroup>
                <FormGroup className="mb-3">
                  <Label htmlFor="relation">
                    {ConfirmPassword} <RequiredField />
                  </Label>
                  <input
                    className={`form-control ${
                      errors.confirmpassword && "is-invalid"
                    }`}
                    id="relation"
                    type="password"
                    name="confirmpassword"
                    defaultValue={formdata.confirmpassword || ""}
                    {...register("confirmpassword", { required: false })}
                  />
                  {/* <span className="text-danger">{errors.firstName && "First name is required"}</span> */}
                </FormGroup>
              </>
            )}
            <div className="text-end btn-mb mt-5">
              <Button
                className="secondary me-2"
                onClick={() =>
                  navigate(`${process.env.PUBLIC_URL}/staff/:layout>}`)
                }
              >
                {Cancel}
              </Button>
              <Button className="primary" type="submit">
                {Submit}
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </Fragment>
  );
};

export default StaffForm;
